import React, { createContext, useContext, useState, ReactNode } from "react";
interface LogoutContextType {
  isSessionExpired: boolean;
  isUnauthorized: boolean;
  showAppExitPopup: boolean;
  handleLogout: () => void;
  handleSessionExpired: () => void;
  setShowAppExitPopup: (status: boolean) => void;
  handleAppExit: (webLink: string) => void;
  handleAppExitConfirm: () => void;
  handleSessionExpiredConfirm: () => void;
  handleUnauthorized: () => void;
  handleUnauthorizedConfirm: () => void;
}

const LogoutContext = createContext<LogoutContextType | undefined>(undefined);

export const useLogout = (): LogoutContextType => {
  const context = useContext(LogoutContext);
  if (!context) {
    throw new Error("useLogout must be used within a LogoutProvider");
  }
  return context;
};
interface LogoutProviderProps {
  children: ReactNode;
}

export const LogoutProvider: React.FC<LogoutProviderProps> = ({ children }) => {
  const [isSessionExpired, setIsSessionExpired] = useState<boolean>(false);
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false);
  const [showAppExitPopup, setShowAppExitPopup] = useState<boolean>(false);
  const [appExitLink, setAppExitLink] = useState<string>("");

  const handleLogout = (): void => {
    setIsSessionExpired(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/");
  };

  const handleUnauthorized = (): void => {
    setIsUnauthorized(true);
  };

  const handleSessionExpired = (): void => {
    setIsSessionExpired(true);
  };

  const handleAppExit = (webLink: string): void => {
    setShowAppExitPopup(true);
    setAppExitLink(webLink);
  };

  const handleAppExitConfirm = (): void => {
    setShowAppExitPopup(false);
    window.open(appExitLink, "_blank", "noopener,noreferrer");
  };

  const handleSessionExpiredConfirm = (): void => {
    setIsSessionExpired(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/");
  };

  const handleUnauthorizedConfirm = (): void => {
    setIsUnauthorized(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace("/");
  };

  return (
    <LogoutContext.Provider
      value={{
        isSessionExpired,
        isUnauthorized,
        showAppExitPopup,
        handleLogout,
        handleSessionExpired,
        setShowAppExitPopup,
        handleAppExit,
        handleAppExitConfirm,
        handleSessionExpiredConfirm,
        handleUnauthorized,
        handleUnauthorizedConfirm,
      }}
    >
      {children}
    </LogoutContext.Provider>
  );
};
